var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},[(_vm.indeterminate)?[_c('div',{staticClass:"indeterminate-fill-small"}),_vm._v(" "),_c('div',{staticClass:"indeterminate-fill-large"})]:_c('div',{staticClass:"progress-fill",style:({ width: `${_vm.percent}%` })})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }